import { userSubscriptionLevel } from '@modules/auth/types'

export const FEATURE_FLAGS_CONFIG = {
  [userSubscriptionLevel.FREE_USER]: {
    hasAccessToChat: false,
    hasAccessToSearch: false,
    hasAccessToContacts: false,
    canSeeAttendees: false,
    cantInitiateChats: false,
    shouldUpgradeToPayingUser: true,
    hasAccessToAlerts: false,
    canDownloadShortlists: false,
    hasAccessToSavedSearch: false,
    hasAccessToEventFiltering: false,
    hasAccessToHistoryFiltering: false,
    hasUnlimitiedAccessToProfiles: false,
    hasAccessToPredictiveSearch: false,
    hasAccessToCompanyMeetings: false,
    hasAccessToMultipleShortlists: false,
    hasAccessToShortlists: false,
    canImportParticipants: false,
    canCopyProspects: false,
    canCreateCustomColumns: false,
    canFilterShortlist: true,
  },
  [userSubscriptionLevel.ECOMMERCE]: {
    hasAccessToChat: true,
    hasAccessToSearch: true,
    hasAccessToContacts: true,
    canSeeAttendees: true,
    cantInitiateChats: true,
    shouldUpgradeToPayingUser: true,
    hasAccessToAlerts: false,
    canDownloadShortlists: false,
    hasAccessToSavedSearch: false,
    hasAccessToEventFiltering: true,
    hasAccessToHistoryFiltering: false,
    hasUnlimitiedAccessToProfiles: true,
    hasAccessToPredictiveSearch: false,
    hasAccessToCompanyMeetings: false,
    hasAccessToMultipleShortlists: false,
    hasAccessToShortlists: true,
    canImportParticipants: false,
    canCopyProspects: false,
    canCreateCustomColumns: true,
    canFilterShortlist: true,
  },
  [userSubscriptionLevel.VENDOR]: {
    hasAccessToChat: false,
    hasAccessToSearch: true,
    hasAccessToContacts: true,
    canSeeAttendees: true,
    cantInitiateChats: false,
    shouldUpgradeToPayingUser: false,
    hasAccessToAlerts: true,
    canDownloadShortlists: true,
    hasAccessToSavedSearch: true,
    hasAccessToEventFiltering: true,
    hasAccessToHistoryFiltering: true,
    hasUnlimitiedAccessToProfiles: true,
    hasAccessToPredictiveSearch: true,
    hasAccessToCompanyMeetings: true,
    hasAccessToMultipleShortlists: true,
    hasAccessToShortlists: true,
    canImportParticipants: true,
    canCopyProspects: true,
    canCreateCustomColumns: true,
    canFilterShortlist: true,
  },
  [userSubscriptionLevel.SUBSCRIBED_USER]: {
    hasAccessToChat: true,
    hasAccessToSearch: true,
    hasAccessToContacts: true,
    canSeeAttendees: true,
    cantInitiateChats: false,
    shouldUpgradeToPayingUser: false,
    hasAccessToAlerts: true,
    canDownloadShortlists: true,
    hasAccessToSavedSearch: true,
    hasAccessToEventFiltering: true,
    hasAccessToHistoryFiltering: true,
    hasUnlimitiedAccessToProfiles: true,
    hasAccessToPredictiveSearch: true,
    hasAccessToCompanyMeetings: true,
    hasAccessToMultipleShortlists: true,
    hasAccessToShortlists: true,
    canImportParticipants: true,
    canCopyProspects: true,
    canCreateCustomColumns: true,
    canFilterShortlist: true,
  },
}
